export enum LanguageType {
  JSON = "json",
  XML = "xml",
}
